import React from 'react';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';

// PHA-1149: the "who, and when" line shown on chart events (Event Log cards, care plan
// provenance, EHR push, care plan notes). Names are display names resolved server-side;
// automation shows up as "System".

export const formatProvenanceTime = (value?: string | null): string => {
  if (!value) return '';
  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return format(date, 'MMM dd, yyyy h:mm a');
  } catch {
    return value;
  }
};

/** "Drafted by Jane Doe on Oct 08, 2026 3:04 PM"; null when there is no user to name. */
export const formatProvenance = (
  label: string,
  name?: string | null,
  at?: string | null
): string | null => {
  if (!name) return null;
  const when = formatProvenanceTime(at);
  return when ? `${label} ${name} on ${when}` : `${label} ${name}`;
};

interface EventProvenanceProps {
  label?: string;
  name?: string | null;
  at?: string | null;
  testId?: string;
}

export const EventProvenance: React.FC<EventProvenanceProps> = ({ label = 'By', name, at, testId }) => {
  const text = formatProvenance(label, name, at);
  if (!text) return null;
  return (
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }} data-testid={testId}>
      {text}
    </Typography>
  );
};

export default EventProvenance;
